import { h } from '@stencil/core';
import Rating from 'eva-components/Rating';
import flightDetailModal from 'store/flightDetailModal';
import { i18n } from 'i18n';

interface AirlineInfoProps {
  airlineCode: string;
  flightId?: string;
  planeModel?: string;
  cabinType?: string;
}

interface RatingValue {
  text: string;
  boxColor: 'good' | 'bad' | 'regular';
  textColor: 'green' | 'red' | 'orange';
}

type RatingCategories = 'veryGood' | 'good' | 'regular' | 'bad';

export default function AirlineInfo({ airlineCode, flightId, planeModel, cabinType }: AirlineInfoProps) {
  const airline = flightDetailModal.airlines.find(airline => airline.code === airlineCode);
  const hasAirline = typeof airline !== 'undefined';
  const hasRating = hasAirline && typeof airline!.rating !== 'undefined';
  const hasFlightId = typeof flightId !== 'undefined';
  const hasPlaneModel = typeof planeModel !== 'undefined';
  const hasCabinType = typeof cabinType !== 'undefined';

  const airlineRating = hasRating ? Math.round(airline?.rating!) / 10 : 0;

  const ratingValue: Record<RatingCategories, RatingValue> = {
    veryGood: { text: i18n.t.flightDetailModal.rating.veryGood, boxColor: 'good', textColor: 'green' },
    good: { text: i18n.t.flightDetailModal.rating.good, boxColor: 'good', textColor: 'green' },
    regular: { text: i18n.t.flightDetailModal.rating.regular, boxColor: 'regular', textColor: 'orange' },
    bad: { text: i18n.t.flightDetailModal.rating.bad, boxColor: 'bad', textColor: 'red' },
  };

  const getRatingText = (rating: number) => {
    switch (true) {
      case rating >= 7.5:
        return ratingValue.veryGood;
      case rating >= 6.5:
        return ratingValue.good;
      case rating >= 5:
        return ratingValue.regular;
      default:
        return ratingValue.bad;
    }
  };

  const ratingValues = hasRating ? getRatingText(airlineRating) : undefined;

  return (
    hasAirline && (
      <div class="airline-info">
        <div class="airline-info-container">
          <span class="airline-logo">
            <img alt="logo" width="25" height="25" src={airline!.logo} />
          </span>
          <span class="airline-info-wrapper">
            <span class="airline-description">
              <p class="name">{airline!.description}</p>
              {hasRating && <Rating rating={airlineRating} size={'sm'} text={ratingValues?.text} boxColor={ratingValues?.boxColor} textColor={ratingValues?.textColor} />}
            </span>
            <span class="airline-data">
              <div class="airline-data-wrapper">
                <ul class="airline-data-superdetail">
                  {hasFlightId && (
                    <li class="flight-number">
                      {i18n.t.flightDetailModal.flight} Nº: {flightId}
                    </li>
                  )}
                  {hasPlaneModel && <li class="flight-model"> {planeModel} </li>}
                  {hasCabinType && (
                    <li>
                      <span class="-eva-3-tc-gray-2">{i18n.t.flightDetailModal.class}:&nbsp;</span>
                      <span class="driver-text">{i18n.t.flightDetailModal.cabinType[cabinType]}</span>
                    </li>
                  )}
                </ul>
              </div>
            </span>
          </span>
        </div>
      </div>
    )
  );
}
